module.exports = __webpack_public_path__ + "img/2.8cdf3d53.gif";